import axios from './axiosConfig.js'

export const getAllDeals = async (dealType) => {
  const response = await axios.get(`/deal?deals=${dealType}`)
  console.log('deal data', response.data)
  return response.data
}

export const getDealById = async (id, dealType) => {
  const response = await axios.get(`/deal/${id}?deals=${dealType}`)
  console.log('response at api', response.data)
  return response.data
}

export const createDeal = async (formData, dealType) => {
  console.log('creating formdata:', formData)
  const data = new FormData()

  // Required fields
  data.append('title', formData.title)
  data.append('deals', dealType)
  data.append('description', formData.description)
  data.append('articleDate', formData.articleDate)
  data.append('cin', formData.cin || formData.cinWorld)
  data.append('brandName', formData.brandName)
  data.append('writtenBy', formData.writtenBy || '')
  data.append('pcCredit', formData.pcCredit || '')
  data.append('categoryId', +formData.categoryId || '')
  data.append('companyInfoBox', formData.companyInfoBox || false)
  data.append('grossGraphBox', formData.grossGraphBox || false)
  data.append('fundRaiseBox', formData.fundRaiseBox || false)
  data.append('showInSlider', formData.showInSlider || false)

  const competitorIds = formData.competitors.map((c) => c.id)
  data.append('competitors', JSON.stringify(competitorIds))

  // File uploads - required for create
  if (formData.image && formData.image[0]) {
    data.append('image', formData.image[0])
  }

  console.log('creating deal with FormData:')
  // Log FormData contents for debugging
  for (let [key, value] of data.entries()) {
    console.log(`${key}:`, value)
  }

  try {
    const response = await axios.post('/deal', data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  } catch (error) {
    console.error('Error creating deal:', error)
    throw error
  }
}

export const updateDeal = async (id, formData, dealType) => {
  // console.log('updating formData', formData)

  const data = new FormData()

  // Required fields - always append these
  data.append('title', formData.title || '')
  data.append('deals', dealType)
  data.append('articleDate', formData.articleDate || '')
  data.append('description', formData.description || '')
  data.append('categoryId', +formData.categoryId || '')

  dealType === 'world'
    ? data.append('cin', formData.cinWorld)
    : data.append('cin', formData.cin)

  // data.append('cin', formData.cinWorld || formData.cin || '')
  data.append('brandName', formData.brandName || '')
  data.append('writtenBy', formData.writtenBy || '')
  data.append('pcCredit', formData.pcCredit || '')
  data.append('companyInfoBox', formData.companyInfoBox || false)
  data.append('grossGraphBox', formData.grossGraphBox || false)
  data.append('fundRaiseBox', formData.fundRaiseBox || false)
  data.append('showInSlider', formData.showInSlider || false)

  const competitorIds = formData.competitors.map((c) => c.id)
  data.append('competitors', JSON.stringify(competitorIds))

  // File uploads - only append if new files are selected
  if (formData.image && formData.image[0]) {
    data.append('image', formData.image[0])
  }

  // console.log('Updating deal with FormData:')
  // Log FormData contents for debugging
  // for (let [key, value] of data.entries()) {
  //   console.log(`${key}:`, value)
  // }

  try {
    const response = await axios.put(`/deal/${id}`, data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  } catch (error) {
    console.error('Error updating deal:', error)
    throw error
  }
}

export const deleteDeal = async (id, dealType, otp) => {
  try {
    const response = await axios.delete(
      `/deal/${id}?deals=${dealType}&otp=${otp}`,
      {
        withCredentials: true,
      }
    )

    console.log('Delete deal response:', response)
    return response.data
  } catch (error) {
    console.error('Error deleting slider:', error)
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to delete deal'
    throw new Error(errorMessage)
  }
}

export const sendMail = async (id, dealType) => {
  console.log('sendMail: data:', id, dealType)
  try {
    const response = await axios.get(`/deal/mail/${id}?deals=${dealType}`, {
      withCredentials: true,
    })

    console.log('mail API response type:', response)
    return response
  } catch (error) {
    console.error('Error fetching sliders:', error)
    throw error
  }
}
